export const debounce = (func, delay) => {
    let debounceHandler;
    // eslint-disable-next-line
    return function () {
        const context = this;
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        clearTimeout(debounceHandler);
        debounceHandler = setTimeout(() => {
            return func.apply(context, args);
        }, delay);
    };
};
